import {
    Box,
    BoxProps,
    Icon,
    Paper,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { memo } from "react";

const TopCircle = memo((props: BoxProps) => {
    return (
        <Box
            sx={{
                position: "absolute",
                top: 0,
                right: 0,
                width: 256,
                height: 256,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: "50%",
                transform: "translate(50%, -50%)",
            }}
        />
    );
});

const BottomCircle = memo((props: BoxProps) => {
    return (
        <Box
            sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: 192,
                height: 192,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: "50%",
                transform: "translate(-50%, 50%)",
            }}
        />
    );
});

export function WelcomeSection() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box sx={{ textAlign: "center", width: "100%" }}>
            {/* Welcome Message */}
            <Stack spacing={2} sx={{ mb: 4, textAlign: "center" }}>
                <Typography variant="h3" color="text.primary">
                    حالا زمان استفاده از پلتفرم پرشین سازه و افزایش فروش شماست.
                </Typography>
                <Typography variant="h4" color="text.secondary">
                    ما در این مسیر رشد همواره همراه شما هستیم.
                </Typography>
            </Stack>

            {/* Discount Card */}
            <Paper
                elevation={8}
                sx={{
                    position: "relative",
                    borderRadius: 4,
                    p: 4,
                    backgroundColor: "#424ebc",
                }}
            >
                <TopCircle />
                <BottomCircle />

                <Stack
                    alignItems="center"
                    sx={{
                        position: "relative",
                        zIndex: 10,
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                            backdropFilter: "blur(8px)",
                            p: 2,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Icon sx={{ color: "white", fontSize: 48 }}>
                            redeem
                        </Icon>
                    </Box>

                    <Stack spacing={3} alignItems="center">
                        <Box
                            sx={{
                                display: "inline-block",
                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                backdropFilter: "blur(8px)",
                                px: 6,
                                py: 2,
                                borderRadius: 25,
                            }}
                        >
                            <Typography
                                sx={{ color: "rgba(255, 255, 255, 0.9)" }}
                            >
                                هدیه‌ی ویژه‌ی شما
                            </Typography>
                        </Box>
                    </Stack>

                    <Paper
                        elevation={3}
                        sx={{
                            backgroundColor: "white",
                            borderRadius: 3,
                            px: 8,
                            py: 4,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                gap: { xs: 0, md: 2 },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "4rem",
                                    fontWeight: "bold",
                                    color: "#424ebc",
                                }}
                            >
                                ۲۰%
                            </Typography>
                            <Typography color="text.secondary" variant="h3">
                                تخفیف برای اولین خرید شما
                            </Typography>
                        </Box>
                    </Paper>

                    <Typography
                        sx={{
                            color: "rgba(255, 255, 255, 0.8)",
                            whiteSpace: isSmallScreen ? "normal" : "nowrap",
                            lineHeight: 1.5,
                        }}
                        variant="h4"
                    >
                        با این تخفیف مسیر رشد فروش خود با پرشین سازه را آغاز
                        کنید
                    </Typography>
                </Stack>
            </Paper>
        </Box>
    );
}
